import React from "react";

export default function Footer() {
  return (
    <footer
      style={{
        textAlign: "center",
        fontSize: "0.9rem",
        marginTop: "2rem",
        padding: "1rem 0",
        backgroundColor: "#f9f9f9",
        color: "#301607",
        borderTop: "1px solid #e5e5e5",
        lineHeight: "1.6",
      }}
    >
      Made with love 🧡 for eternal knowledge seekers.
      <br />
      Visit:{" "}
      <a
        href="https://mindslog.com"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#301607", fontWeight: "500", textDecoration: "none" }}
      >
        mindslog.com
      </a>
    </footer>
  );
}